export const toHashLabel = (v: string) =>
  v
    .replace('v', '')
    .replace(/(\d{1,2})(\d*)/, (_: string, maj: string, min: string) => (min ? `${maj}.${min}` : maj))
    .replace(/\.0$/, '');

export const sections = [
  { label: 'DISGENET statistics', value: 'gdaStatistics', group: 'Statistics' },
  { label: 'Gene types', value: 'gene_type', group: 'Statistics' },
  { label: 'Variant types', value: 'variant_type', group: 'Statistics' },
  { label: 'Schema', value: 'schema', group: 'Data' },
  { label: 'Sources', value: 'sources', group: 'Data' },
  { label: 'Metrics', value: 'metrics', group: 'Data' },
  { label: 'Attributes', value: 'attributes', group: 'Data' },
  { label: 'DISGENET Association Type Ontology', value: 'assoctypeont', group: 'Data' },
  { label: 'How to cite us', value: 'cite_us', group: 'How To Cite Us' },
];

export const formatVersion = (v: string): string => {
  const withoutV = v.replace(/^v/, '');

  if (/^\d{4}$/.test(withoutV)) {
    const major = parseInt(withoutV.slice(0, 2), 10);
    const minor = parseInt(withoutV.slice(2, 3), 10);
    const patch = parseInt(withoutV.slice(3), 10);
    return `${major}.${minor}.${patch}`;
  }

  if (/^\d{3}$/.test(withoutV)) {
    const major = parseInt(withoutV.slice(0, 2), 10);
    const minor = parseInt(withoutV.slice(2), 10);
    return `${major}.${minor}`;
  }

  if (/^\d{2}$/.test(withoutV)) {
    return `${parseInt(withoutV, 10)}`;
  }

  return withoutV;
};

export const formatNumber = (n: unknown) => {
  if (typeof n === 'number' || typeof n === 'string') {
    return Number(n).toLocaleString();
  }
  return 'N/A';
};

export const isReleaseCategory = (category: string): boolean => {
  return category.includes('release');
};
